import { Component } from 'react'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import PropTypes from 'prop-types'

export default class GeotaggedImageLayer extends Component {
  componentDidMount() {
    this.source = new VectorSource()

    this.layer = new VectorLayer({
      zIndex: this.props.zIndex,
      source: this.source,
      style: this.props.style,
    })

    this.updateFeatures()

    this.props.map.addLayer(this.layer)
    this.props.onLayerCreated(this.layer)
  }

  componentWillUnmount() {
    this.props.map.removeLayer(this.layer)
    this.props.onLayerRemoved(this.layer)
  }

  componentDidUpdate(oldProps) {
    if (oldProps.style !== this.props.style) {
      this.layer.setStyle(this.props.style)
    }

    if (oldProps.geojson !== this.props.geojson) {
      this.updateFeatures()
    }
  }

  updateFeatures() {
    const features = new GeoJSON().readFeatures(this.props.geojson, {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857',
    })

    features.forEach(f => f.set('layerId', this.props.layerId))
    this.source.clear()
    this.source.addFeatures(features)
  }

  render() {
    return <span />
  }
}

GeotaggedImageLayer.propTypes = {
  geojson: PropTypes.object,
  layerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  zIndex: PropTypes.number,
  style: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  map: PropTypes.object,
  onLayerCreated: PropTypes.func,
  onLayerRemoved: PropTypes.func,
}
